


































































import Vue from 'vue';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import Sticky from 'vue-sticky-directive';
import PropertyMenu from '@/components/property/property-menu.vue';
import ViewpointCreate from '@/components/viewpoint/viewpoint-create.vue';
import ViewpointResults from '@/components/viewpoint/viewpoints-results.vue';

export default Vue.extend({

  name: 'ViewpointsPage',

  directives: {
    Sticky
  },

  components: {
    'property-menu': PropertyMenu,
    'viewpoint-results': ViewpointResults,
    ViewpointCreate,
  },

  props: {
    viewpointName: {
      type: String,
      default: 'Default Viewpoint',
    },
    factorGroupName: {
      type: String,
      default: 'Score',
    },
    status: {
      type: String,
      default: 'ok',
      required: false,
      validator: (value) => {
        return [
          'ok',
          'loading',
          'syncing',
          'synced',
          'version-conflict',
          'error'
        ].indexOf(value) !== -1
      }
    },
  },

  data() {
    return {
      updatedFlag: 0,
      showFavourites: false,
      searchQuery: '',
      dialog: false,
      drawer: false,
    };
  },

  created() {
    console.log('[ ViewpointPage created() ]');
    let name: any = this.$route.name;
    if (name === 'mls') {
      this.showFavourites = false;
    }
    if (name === 'favourites') {
      this.showFavourites = true;
    }
    let subSection: any = this.$route.params.subSection;
    if (subSection === 'mls') {
      this.showFavourites = false;
    }
    if (subSection === 'favourites') {
      this.showFavourites = true;
    }
  },

  mounted() {
  },

  watch: {
    routeName(newVal, oldVal) {
      if (newVal === 'mls') {
        this.showFavourites = false;
      }
      if (newVal === 'favourites') {
        this.showFavourites = true;
      }
    },
    routeParam(newVal, oldVal) {
      if (newVal === 'mls') {
        this.showFavourites = false;
      }
      if (newVal === 'favourites') {
        this.showFavourites = true;
      }
    },
  },

  computed: {
    
     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
   
    routeName(): any {
      return this.$route.name;
    },
    
    routeParam(): any {
      return this.$route.params.subSection;
    },
    
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },

    formatDate() {
      let newDate: Date = new Date
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

  },

  methods: {

    newViewpoint() {
      store.dispatch('createInstance');
    },
    
    switchView(event: any) {
      this.showFavourites = event;
    },
    
    updateSearch(event: any) {
      console.log('[SEARCH UPDATED]: ' + event);
      this.searchQuery = event;
      this.updatedFlag++;
    },
    
    factorsUpdated() {
      this.updatedFlag++;
    },
    
    openFactors() {
      this.drawer = true;
    },

  },


});

